module.exports = __webpack_public_path__ + "media/img/corporate/logos/axpo-333c0f11052d323252dacf4440c59151.svg";